import {
  Box,
  Button,
  Grid,
  Typography,
  Divider,
  Card,
  CardMedia,
  CardContent
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArticleIcon from "@mui/icons-material/Article";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actionType from "../../store/actions";
import { Stack } from "@mui/system";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import moment from "moment-timezone";
import { getLocaleDateTime } from "../../shared/constants/common";

const Deleted = (props) => {
  const columns = [
    {
      field: "type",
      headerName: "CATEGORY",
      minWidth: 200,
      maxWidth: 250,
      renderCell: ({ row }) => {
        return <Typography>{row.type}</Typography>;
      }
    },
    {
      field: "sentDate",
      headerName: "DATE",
      type: "date",
      minWidth: 200,
      maxWidth: 250,
      renderCell: ({ row }) => {
        return (
          <Typography>
            {/* {moment.utc(row.sentDate).tz("America/New_York").format("MM/DD/YYYY hh:mm A") + " EST"} */}
            {getLocaleDateTime(row?.sentDate, "MM/DD/YYYY hh:mm A z", true)}
          </Typography>
        );
      },
      sortComparator: (v1, v2) => {
        return moment(v1).valueOf() - moment(v2).valueOf();
      }
    },
    {
      field: "subject",
      headerName: "SUBJECT",
      // flex: 1,
      minWidth: 400,
      renderCell: ({ row }) => {
        return <Typography>{row.subject}</Typography>;
      }
    }
  ];

  //const practiceData = useSelector((state) => state.homeReducer.practiceData);
  //const profileData = useSelector((state) => state.homeReducer.profileData);

  const {
    actions,
    ListOfDeletedMessages,
    ListOfMessagesLoading,
    updateMessagesLoading,
    downloadedFileUrl,
    profileData,
    practiceInfoData
  } = props;
  const [rows, setRows] = useState([]);
  const [openSelectedMessage, setOpenSelectedMessage] = useState({});
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const userId = localStorage.getItem("userId");
  const patientId = localStorage.getItem("patientId");
  const practiceId = localStorage.getItem("practiceId");

  useEffect(() => {
    if (!Object.keys(profileData).length) {
      let payload = {
        practiceId,
        patientId
      };
      actions.getProfileData(payload);
    }
  }, []);
  useEffect(() => {
    if (!Object.keys(practiceInfoData).length) {
      let payload = {
        practiceId
      };
      actions.getPracticeInfoData(payload);
    }
  }, [practiceId]);

  const updateSelectedMessage = ({ row }) => {
    setOpenSelectedMessage(row);
  };
  const messageBackClickHandler = () => {
    setOpenSelectedMessage({});
  };
  const moveToInboxHandler = () => {
    if (selectedMessages.length) {
      selectedMessages.map((item) => {
        delete item.id;
      });
    }
    let updatedMessages = selectedMessages.map((value) => ({
      ...value,
      body: null,
      sentDate: null,
      status: "Inbox",
      updationDate: null
    }));

    let payload = {
      userId,
      updatedMessages
    };
    actions.updateMultipleMessages(payload);
    setSelectionModel([]);
  };
  const downloadHandler = () => {
    selectedMessages[0].messageAttachment.map((item) => {
      let payload = {
        filePath: item.attachmentUrl
      };
      actions.getFile(payload);
    });
    setSelectionModel([]);
  };
  useEffect(() => {
    if (downloadedFileUrl) {
      let a = document.createElement("a");
      a.href = downloadedFileUrl;
      a.download = "document.pdf";
      a.click();
      actions.resetMessageExecuteStatus();
    }
  }, [downloadedFileUrl]);

  useEffect(() => {
    if (userId) {
      let payload = {
        userId: userId,
        messagesStatus: "Deleted"
      };
      actions.getMessagesList(payload);
    }
  }, [userId, updateMessagesLoading]);

  useEffect(() => {
    if (ListOfDeletedMessages) {
      let rows = ListOfDeletedMessages.messageList.map((item, index) => {
        item.id = index;
        return item;
      });
      setRows(rows);
    }
  }, [ListOfDeletedMessages]);
  const redirectToAnotherPage = (Url) => {
    //let fertLink = "https://fertilityaccessprogram.com/";
    window.open(Url, "_blank", "noreferrer");
  };
  return (
    <Box>
      <Grid container className="mt-15">
        <Grid item xs={1}>
          {Object.keys(openSelectedMessage).length != 0 && (
            <Button onClick={messageBackClickHandler}>
              <KeyboardBackspaceIcon />
            </Button>
          )}
        </Grid>
        <Grid item sx={6} lg={1.5}>
          <Button
            variant="outlined"
            onClick={moveToInboxHandler}
            disabled={selectedMessages.length == 0}>
            Move to inbox
          </Button>
        </Grid>
        <Grid item sx={6} lg={8.6}>
          <Button
            variant="outlined"
            onClick={downloadHandler}
            disabled={
              selectedMessages.length != 1 || !selectedMessages[0]?.messageAttachment?.length
            }>
            Download Attachment
          </Button>
        </Grid>
      </Grid>
      {Object.keys(openSelectedMessage).length != 0 ? (
        <Box className="message-body">
          <Stack>
            <Stack gap={1}>
              <Typography>{openSelectedMessage.type}</Typography>
              <Typography>{openSelectedMessage.subject}</Typography>
              <Typography>
                {/* moment
                  .utc(openSelectedMessage.sentDate)
                  .tz("America/New_York")
                  .format("MM/DD/YYYY hh:mm A") + " EST" */}
                {getLocaleDateTime(openSelectedMessage?.sentDate, "MM/DD/YYYY hh:mm A z", true)}
              </Typography>
            </Stack>

            <Divider fitted="true" sx={{ mt: 2, mb: 2 }} />
            <Typography> Hello {profileData?.firstName},</Typography>
            <br />
            <Typography
              style={{ whiteSpace: "pre-line" }}
              component="span"
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: openSelectedMessage?.body?.split("#br#").join("<br />")
              }}
            />

            <Stack className="mt-15">
              <Typography>Thank you,</Typography>
              {(openSelectedMessage.type === "Enrollment" && (
                <>
                  <Typography sx={{ mb: 1, mt: 1 }}>{practiceInfoData.name}</Typography>
                </>
              )) || (
                <>
                  <Typography sx={{ mb: 1, mt: 1 }}>Fertility Access</Typography>
                </>
              )}
            </Stack>
            {(openSelectedMessage.type === "Enrollment" && (
              <>
                <Link
                  underline="none"
                  target="_blank"
                  onClick={() => redirectToAnotherPage(practiceInfoData.website)}
                  style={{ color: "#1BA3AD" }}>
                  {practiceInfoData.website}
                </Link>
              </>
            )) || (
              <>
                <Link
                  underline="none"
                  target="_blank"
                  onClick={() => redirectToAnotherPage("https://fertilityaccessprogram.com/")}
                  style={{ color: "#1BA3AD" }}>
                  https://fertilityaccessprogram.com/
                </Link>
              </>
            )}
            <br />
            <Typography>Please do not respond this message.</Typography>
          </Stack>
          <Stack direction="row" gap={2}>
            {openSelectedMessage.hasAttachment &&
              openSelectedMessage.messageAttachment.map((item, index) => {
                return (
                  <Card className="msg-attachment" key={index}>
                    <CardMedia
                      component="iframe"
                      src={item.attachmentUrl}
                      width="100%"
                      height="80"
                      scrolling="no"
                    />
                    <CardContent>
                      <Stack direction="row" className="flex-between">
                        <Stack direction="row" className="align-center" spacing={1}>
                          <ArticleIcon color="primary" />
                          <Typography>{item.attachFileName}</Typography>
                        </Stack>
                        <Link to={item.attachmentUrl} target="_blank">
                          <OpenInNewIcon />
                        </Link>
                      </Stack>
                    </CardContent>
                  </Card>
                );
              })}
          </Stack>
        </Box>
      ) : (
        <Box className="grid-style1">
          <DataGrid
            sx={{ mx: 1 }}
            loading={ListOfMessagesLoading}
            rowsPerPageOptions={[10, 25, 50]}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            pagination
            rows={rows}
            columns={columns}
            onRowClick={(e) => {
              updateSelectedMessage(e);
            }}
            checkboxSelection={true}
            onSelectionModelChange={(ids) => {
              setSelectionModel(ids);
              const selectedIds = new Set(ids);
              setSelectedMessages(rows.filter((row) => selectedIds.has(row.id)));
            }}
            selectionModel={selectionModel}
            // autoHeight={true}
          />
        </Box>
      )}
    </Box>
  );
};
const mapStateToProps = ({ messageReducer, profileReducer }) => {
  return {
    ListOfDeletedMessages: messageReducer.ListOfDeletedMessages,
    ListOfMessagesLoading: messageReducer.ListOfMessagesLoading,
    updateMessagesLoading: messageReducer.updateMessagesLoading,
    downloadedFileUrl: messageReducer.downloadedFileUrl,
    profileData: profileReducer.profileData,
    practiceInfoData: profileReducer.practiceInfoData
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    getMessagesList: (payload) => {
      dispatch(actionType.getMessagesList(payload));
    },
    updateMultipleMessages: (payload) => {
      dispatch(actionType.updateMultipleMessages(payload));
    },
    getFile: (payload) => {
      dispatch(actionType.getFile(payload));
    },
    resetMessageExecuteStatus: () => {
      dispatch(actionType.resetMessageExecuteStatus());
    },
    getProfileData: (payload) => {
      dispatch(actionType.getProfileData(payload));
    },
    getPracticeInfoData: (payload) => {
      dispatch(actionType.getPracticeInfoData(payload));
    }
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(Deleted);
